import { render, staticRenderFns } from "./DialogEditUserBank.vue?vue&type=template&id=c35f567c&"
import script from "./DialogEditUserBank.vue?vue&type=script&lang=js&"
export * from "./DialogEditUserBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports